const toJS = (value, fallback) => {
  if (value == null) return fallback;
  if (typeof value.toJS === "function") return value.toJS();
  return value;
};

const getBulkAnalyseState = (state) => state.bulkAnalyse;

export const getBulkAnalyseJob = (state) => toJS(getBulkAnalyseState(state)?.get("job"), null);

export const getBulkAnalyseActiveLoaded = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("activeLoaded"));

export const getBulkAnalysePreview = (state) =>
  toJS(getBulkAnalyseState(state)?.get("preview"), null);

export const getBulkAnalysePreviewLoading = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("previewLoading"));

export const getBulkAnalysePreviewError = (state) =>
  getBulkAnalyseState(state)?.get("previewError") || "";

export const getBulkAnalyseCreateLoading = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("createLoading"));

export const getBulkAnalyseCreateError = (state) =>
  toJS(getBulkAnalyseState(state)?.get("createError"), null);

export const getBulkAnalyseStopLoading = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("stopLoading"));

export const getBulkAnalyseStopError = (state) =>
  getBulkAnalyseState(state)?.get("stopError") || "";

export const getBulkAnalyseRetryLoading = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("retryLoading"));

export const getBulkAnalyseDismissLoading = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("dismissLoading"));

export const getBulkAnalyseItems = (state) => toJS(getBulkAnalyseState(state)?.get("items"), []);

export const getBulkAnalyseItemsPagination = (state) =>
  toJS(getBulkAnalyseState(state)?.get("itemsPagination"), {});

export const getBulkAnalyseItemsStatus = (state) =>
  getBulkAnalyseState(state)?.get("itemsStatus") || "all";

export const getBulkAnalyseItemsLoading = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("itemsLoading"));

export const getBulkAnalyseJobOpen = (state) =>
  Boolean(getBulkAnalyseState(state)?.get("jobOpen"));

export const getBulkAnalyseFinishedVersion = (state) =>
  Number(getBulkAnalyseState(state)?.get("finishedVersion") || 0);

export const isBulkAnalyseRunning = (state) => getBulkAnalyseJob(state)?.status === "running";
